if(document.querySelectorAll(".block_offer-popup").length > 0) {
let productRewardPopElements = document.querySelectorAll(
  ".block_product_promotion .block_product-campaign, .block_card-offer-info-inner"
);
productRewardPopElements.forEach((productrewardpop) => {  
productrewardpop.addEventListener("click", (event) => {
	document.querySelector("body").classList.add("over-hidden-offeropen");
	document.querySelector(".block_offer-popup").classList.toggle("hidden");
});
})
document.addEventListener("click", (event) => {
    if (event.target.closest(".block_offer-popup-inner .block_offer-popup-close")) {
        document.querySelector("body").classList.remove("over-hidden-offeropen");
        document.querySelector(".block_offer-popup").classList.toggle("hidden");
    }
});

document.addEventListener('click', function(e) {
	var container = document.querySelector('.block_offer-popup-inner');
    if(document.querySelectorAll(".block_product-campaign").length > 0){
     	var container2 = document.querySelector('.block_product-campaign'); 
    }else{
       	var container2 = document.querySelector('.block_card-offer-info-inner'); 
    }  
	var target = e.target;
	if (!container.contains(target) && !container2.contains(target)) {
		var isContainerClicked = target.classList.contains('block_product-campaign');
		var isDescendantClicked = container.contains(target);
		if (!isContainerClicked && !isDescendantClicked) {
			var kalviyoElements = document.querySelectorAll('.block_offer-popup');
			kalviyoElements.forEach(function(element) {
				element.classList.add('hidden');
				document.querySelector("body").classList.remove("over-hidden-offeropen");
			});
		}
	}
});
}
